import React, { useState } from "react";
import { X } from "lucide-react";
import { useContent } from "../context/ContentContext";

const Gallery = () => {
  const { gallery } = useContent();
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="relative py-24 md:py-32 bg-neutral-950 border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <span className="accent-bar" />
            <span className="text-xs uppercase tracking-[0.35em] text-neutral-400 font-heading">
              05 — Gallery
            </span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl text-white leading-none">
            IN THE <span className="text-red-600">TRENCHES</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {gallery.map((g) => (
            <button
              key={g.id}
              onClick={() => setActive(g)}
              className="relative group overflow-hidden rounded-sm border border-neutral-800 bg-neutral-900 text-left"
            >
              <img
                src={g.src}
                alt={g.caption}
                loading="lazy"
                className="w-full h-[420px] md:h-[520px] object-cover img-reveal"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 flex items-end justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-red-500 font-heading">
                    Frame {String(g.id).padStart(2, "0")}
                  </div>
                  <div className="font-display text-2xl text-white">
                    {g.caption}
                  </div>
                </div>
                <div className="opacity-0 group-hover:opacity-100 transition-opacity text-xs uppercase tracking-[0.25em] text-white border border-white/40 rounded-sm px-3 py-1">
                  View
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-sm flex items-center justify-center p-5"
        >
          <button
            className="absolute top-5 right-5 text-white p-2 rounded-sm border border-neutral-700 hover:border-red-500"
            onClick={() => setActive(null)}
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
          <img
            src={active.src}
            alt={active.caption}
            className="max-w-full max-h-[85vh] object-contain rounded-sm"
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
